/**
 * Validate route rules used by the regulated-site collection boundary.
 * Exact paths match literally. A single trailing `*` is the only wildcard and
 * means prefix matching (for example `/care/*`).
 */
export function normalizePathAllowlist(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const rules: string[] = [];
  for (const candidate of value) {
    if (typeof candidate !== "string") continue;
    const rule = candidate.trim();
    if (!validPathRule(rule) || rules.includes(rule)) continue;
    rules.push(rule);
  }
  return rules;
}

export function validPathRule(rule: string): boolean {
  if (!rule || rule.length > 512 || !rule.startsWith("/")) return false;
  if (rule.includes("?") || rule.includes("#") || rule.includes("\\"))
    return false;
  const firstStar = rule.indexOf("*");
  return (
    firstStar === -1 ||
    (firstStar === rule.length - 1 &&
      rule.lastIndexOf("*") === firstStar &&
      rule[firstStar - 1] === "/")
  );
}

export function pathAllowed(
  pathname: string,
  rules: readonly string[],
): boolean {
  if (!pathname.startsWith("/") || rules.length === 0) return false;
  for (const rule of rules) {
    if (!validPathRule(rule)) continue;
    if (rule.endsWith("*")) {
      if (pathname.startsWith(rule.slice(0, -1))) return true;
    } else if (pathname === rule) {
      return true;
    }
  }
  return false;
}
